import React from "react";
import {
  SiPython,
  SiJavascript,
  SiPhp,
  SiHtml5,
  SiCss,
  SiTailwindcss,
  SiReact,
  SiStreamlit,
  SiScikitlearn,
  SiTensorflow,
  SiKeras,
  SiHuggingface,
  SiLangchain,
  SiCrewai,
  SiFastapi,
  SiExpress,
  SiNestjs,
  SiNodedotjs,
  SiGraphql,
  SiMongodb,
  SiMysql,
  SiPostgresql,
  SiSqlite,
  SiQdrant,
  SiDocker,
  SiGit,
  SiGithub,
  SiGitlab,
  SiVercel,
  SiJupyter,
  SiRedux,
  SiRedis,
} from "react-icons/si";
import LogoLoop from "./LogoLoop";

const TECH_LOGOS = [
  { Icon: SiPython, color: "#3776AB" },
  { Icon: SiJavascript, color: "#F7DF1E" },
  { Icon: SiPhp, color: "#777BB4" },
  { Icon: SiHtml5, color: "#E34F26" },
  { Icon: SiCss, color: "#663399" },
  { Icon: SiTailwindcss, color: "#06B6D4" },
  { Icon: SiReact, color: "#61DAFB" },
  { Icon: SiStreamlit, color: "#FF4B4B" },
  { Icon: SiScikitlearn, color: "#F7931E" },
  { Icon: SiTensorflow, color: "#FF6F00" },
  { Icon: SiKeras, color: "#D00000" },
  { Icon: SiHuggingface, color: "#FFD21E" },
  { Icon: SiLangchain, color: "#1C3C3C" },
  { Icon: SiCrewai, color: "#FF5A50" },
  { Icon: SiFastapi, color: "#009688" },
  { Icon: SiExpress, color: "#000000" },
  { Icon: SiNestjs, color: "#E0234E" },
  { Icon: SiNodedotjs, color: "#5FA04E" },
  { Icon: SiGraphql, color: "#E10098" },
  { Icon: SiMongodb, color: "#47A248" },
  { Icon: SiMysql, color: "#4479A1" },
  { Icon: SiPostgresql, color: "#4169E1" },
  { Icon: SiSqlite, color: "#003B57" },
  { Icon: SiQdrant, color: "#EA2845" },
  { Icon: SiDocker, color: "#2496ED" },
  { Icon: SiGit, color: "#F05032" },
  { Icon: SiGithub, color: "#181717" },
  { Icon: SiGitlab, color: "#FC6D26" },
  { Icon: SiVercel, color: "#000000" },
  { Icon: SiJupyter, color: "#F37626" },
  { Icon: SiRedux, color: "#764ABC" },
  { Icon: SiRedis, color: "#FF4438" },
];

const TechLogos = () => {
  const logos = TECH_LOGOS.map(({ Icon, color }) => ({
    node: <Icon color={color} />,
    title: Icon.name.replace(/^Si/, ""),
    href: "#skills",
  }));

  return (
    <div
      className="relative overflow-hidden py-8"
      style={{ height: "140px", position: "relative" }}
    >
      <LogoLoop
        logos={logos}
        speed={80}
        direction="left"
        logoHeight={48}
        gap={54}
        hoverSpeed={0}
        scaleOnHover
        fadeOut
        fadeOutColor="var(--background)"
        ariaLabel="Technology skills"
      />
    </div>
  );
};

export default TechLogos;
